module.exports = __webpack_public_path__ + "static/img/injectionProduction.55943f7b.png";